import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, LL_V_L, Button, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { Component_SwitchView } from '@nu-art/permissions-frontend/ui/Component_SwitchView';
import { QScrollWrapper } from '@app/hcs-frontend';
import { DefaultEditor_TextArea } from '@app/styles/frontend/ui-manager/ui-components';
import { ICONS } from '@app/styles';
import { cloneObj } from '@nu-art/ts-common';
import { Component_PrognosisItemEditor } from './Component_PrognosisItemEditor.js';
import './Component_PrognosisEditor.scss';
import { TS_EditableItemComponentProto } from '@nu-art/thunderstorm-frontend/editable-item';
import { initialPrognosis } from '@app/dp-shared';
const ViewMode_View = 'view';
const ViewMode_Edit = 'edit';
export class Component_PrognosisEditor extends TS_EditableItemComponentProto {
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.editMode = nextProps.editMode;
        return state;
    }
    // ######################## Logic ########################
    getViewMode = () => this.state.editMode ? ViewMode_Edit : ViewMode_View;
    addPrognosis = async () => {
        const prognosis = this.state.editable.editProp('prognosis', []);
        await prognosis.updateArrayAt(cloneObj(initialPrognosis));
    };
    // ######################## Render ########################
    render() {
        return _jsxs(LL_V_L, { className: 'prognosis-editor', children: [this.renderPrognosis(), this.renderPrognosisNotes()] });
    }
    renderPrognosisNotes = () => {
        const editable = this.state.editable;
        return _jsx(TS_PropRenderer.Vertical, { label: 'Prognosis Notes', error: editable.hasError('prognosisNotes'), children: _jsx(Component_SwitchView, { mode: this.getViewMode(), modes: [
                    {
                        key: ViewMode_View,
                        renderer: () => _jsx("p", { children: editable.item.prognosisNotes })
                    },
                    {
                        key: ViewMode_Edit,
                        renderer: () => _jsx(DefaultEditor_TextArea, { editable: editable, prop: 'prognosisNotes' })
                    }
                ] }) });
    };
    renderPrognosis = () => {
        const prognosisArr = this.state.editable.editProp('prognosis', []);
        const editMode = this.state.editMode;
        return _jsxs(TS_PropRenderer.Vertical, { label: 'Prognosis', children: [editMode && _jsxs(Button, { variant: 'primary', onClick: this.addPrognosis, children: [_jsx(ICONS.advisor_v5_plus.component, {}), " Add Prognosis"] }), _jsx(QScrollWrapper, { children: prognosisArr.item.map((_prognosis, index) => {
                        const prognosis = prognosisArr.editProp(index, {});
                        const className = _className('prognosis-card', editMode && 'edit-mode');
                        return _jsxs("div", { className: className, children: [editMode && _jsx(ICONS.bin.component, { className: 'prognosis-card__delete', onClick: async () => {
                                        await prognosisArr.removeArrayItem(index);
                                    } }), _jsx(Component_PrognosisItemEditor, { editable: prognosis, editMode: this.state.editMode }, index)] }, index);
                    }) })] });
    };
}
//# sourceMappingURL=Component_PrognosisEditor.js.map